import styled, { createGlobalStyle } from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont, pxToCssFontSize } from '@vfit/shared/themes';
import { ICSSProps } from './coverageToolModal.models';

export const OverlayGlobalStyle = createGlobalStyle`
  body {
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: fixed;
  }

  header {
    display: none !important;
  }

  #sticky-offer-product {
    display: none;
  }

  #sticky-offer-summary {
    visibility: hidden;
  }
`;

export const CoverageToolModalContainer = styled.div`
  position: fixed;
  overflow-y: scroll;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }

  top: 0;
  z-index: 4;
  width: 100%;
`;

export const ErrorMsg = styled.p<ICSSProps>`
  ${(props) => (props.isManual ? '' : 'display: none;')}

  @keyframes fadein {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  color: ${colors.$e60000};
  ${pxToCssFont(14, 18)}
  font-family: ${fonts.regular};
  text-align: left;
`;

export const P = styled.p`
  ${pxToCssFont(18, 24)}
  font-family: ${fonts.light};
  text-align: center;
  color: #333;
  margin-top: 0.5rem;
  margin-bottom: 2rem;
`;

export const Title = styled.h3`
  margin: 0;
  ${pxToCssFontSize(30)}
  font-family: ${fonts.exbold};
  font-weight: 400;
  text-align: center;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFontSize(42)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFontSize(36)}
  }
`;

export const CoverageToolContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const CoverageToolContent = styled.div`
  margin-top: 32px;
  margin-left: 20px;
  margin-right: 20px;

  @media (min-width: ${breakpoints.tablet}) {
    margin-top: 64px;
    margin-left: 40px;
    margin-right: 40px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-top: 60px;
    margin-left: 54px;
    margin-right: 54px;
  }
`;

export const CoverageToolContentButton = styled.div`
  margin-bottom: 32px;
  margin-left: 20px;
  margin-right: 20px;

  @media (min-width: ${breakpoints.tablet}) {
    margin-bottom: 64px;
    margin-left: 40px;
    margin-right: 40px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-bottom: 60px;
    margin-left: 54px;
    margin-right: 54px;
  }
`;

export const CoverageToolContentButtonAuto = styled.div`
  position: absolute;
  bottom: 32px;
  right: 20px;
  left: 20px;

  @media (min-width: ${breakpoints.tablet}) {
    bottom: 64px;
    left: 40px;
    right: 40px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    bottom: 60px;
    left: 54px;
    right: 54px;
  }
`;

export const ManualContainer = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 32px;
  text-align: start;

  @media (min-width: ${breakpoints.tablet}) {
    margin-left: 40px;
    margin-right: 40px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-left: 54px;
    margin-right: 54px;
  }
`;
